import {
  Box,
  CircularProgress,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Menu,
  MenuItem,
  Skeleton,
  TextField,
  Tooltip,
  Typography,
  useMediaQuery,
} from "@mui/material";
import moment from "moment";
import React, { useState } from "react";
import { s3baseUrl } from "src/config";
import DownloadOutlinedIcon from "@mui/icons-material/DownloadOutlined";
import CallMadeIcon from "@mui/icons-material/CallMade";
import DownloadIcon from "@mui/icons-material/Download";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import DriveFileRenameOutlineOutlinedIcon from "@mui/icons-material/DriveFileRenameOutlineOutlined";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import Iconify from "src/components/Iconify";
import {
  getColorValueFromType,
  getIconValueFromType,
} from "src/constants/constants";
import { LoadingButton } from "@mui/lab";
import { useSnackbar } from "notistack";
import {
  _delete_task_attachments,
  _download_attachment,
  _rename_task_attachments,
} from "src/DAL/taskDetailDrawer";
import { MuiDialog } from "src/components";
import { saveAs } from "file-saver";

export default function TaskAttachments({
  attachments,
  setAttachments,
  localAttachmentsFiles,
  setLocalAttachmentsFiles,
  taskId,
  canEditTask,
}) {
  const is_mobile_view = useMediaQuery("(max-width:600px)");
  const { enqueueSnackbar } = useSnackbar();
  const [hoveredAttachmentId, setHoveredAttachmentId] = useState();
  const [selectedAttachment, setSelectedAttachment] = useState();
  const [isDeletingAttachment, setIsDeletingAttachment] = useState(false);
  const [isDownloading, setIsDownloading] = useState(false);
  const [deleteFileDialogOpen, setDeleteFileDialogOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const openAttachmentDialog = Boolean(anchorEl);
  const [isOpenRenameDialog, setIsOpenRenameDialog] = useState(false);
  const [isRenameLoading, setIsRenameLoading] = useState(false);
  const [fileName, setFileName] = useState();

  const handleRemoveAttachment = async () => {
    let req_obj = {
      task_id: taskId,
      attachment_id: selectedAttachment._id,
    };
    console.log(req_obj, "my obj");

    const res = await _delete_task_attachments(req_obj);
    if (res.code == 200) {
      let taskDetail = res?.task_detail;
      console.log(res, attachments, taskDetail.attachments, "my task detail");

      setAttachments(taskDetail?.attachments);
      setLocalAttachmentsFiles([]);
      setSelectedAttachment();
    } else {
      enqueueSnackbar(res.message, { variant: "error" });
    }
    setDeleteFileDialogOpen(false);
    setIsDeletingAttachment(false);
    // setAttachments(taskDetail?.attachments);
  };

  const handleCopyAttachmentLink = (item) => {
    let filePath = s3baseUrl + item?.attachment_path;
    console.log(filePath, "File Path");
    window.navigator.clipboard.writeText(filePath);
    enqueueSnackbar("Link copied to clipboard", { variant: "success" });
  };

  function findingExtention(name, path) {
    let tempName = name;
    if (hasFileExtension(name)) {
      tempName = name.replace(/\.[a-zA-Z0-9]+$/, "");
    }
    let extractedExtension = "";
    if (path) {
      const match = path.match(/\.([a-zA-Z0-9]+)(?=\?|#|$)/);
      if (match) {
        extractedExtension = match[1];
      }
    }
    console.log(tempName, extractedExtension, "zzzzzzzzzzzzz");

    return tempName + "." + extractedExtension;
  }

  function hasFileExtension(filename) {
    return /\.[a-zA-Z0-9]+$/.test(filename);
  }

  const handleClickDownload = async (item) => {
    console.log(item, "clicked Item");
    setSelectedAttachment(item);
    setIsDownloading(true);

    const fileName =
      findingExtention(item.attachment_name, item.attachment_path) ||
      "downloaded_file";
    console.log(fileName, "File Name");

    let my_obj = {
      task_id: taskId,
      attachment_id: item._id,
    };
    const response = await _download_attachment(my_obj);
    if (!response.ok) {
      enqueueSnackbar("Download failed...", { variant: "error" });
    } else {
      const blob = await response.blob();
      console.log("Blob File => ", blob);
      saveAs(blob, fileName);
    }
    setIsDownloading(false);
  };

  const handleClickDownloadIcon = () => {
    setIsDownloading(true);
    handleClickDownload(selectedAttachment);
  };

  const handleOpenAttachmentDialog = (e) => {
    setAnchorEl(e.currentTarget);
  };

  const handleCloseAttachmentDialog = () => {
    setAnchorEl(null);
  };
  const handleClickRemove = (e) => {
    handleCloseAttachmentDialog();
    setDeleteFileDialogOpen(true);
  };

  const handleClickOnOpenInNewTab = (item) => {
    let filePath = s3baseUrl + item?.attachment_path;
    console.log(filePath, "File Path");
    window.open(filePath, "_blank");
  };

  const handelRenameFile = async (e) => {
    e.preventDefault();
    setIsRenameLoading(true);
    let data_obj = {
      task_id: taskId,
      attachment_id: selectedAttachment?._id,
      attachment_name: fileName,
    };
    console.log(data_obj, "name");
    const result = await _rename_task_attachments(data_obj);
    if (result.code == 200) {
      console.log(result, "my result");
      setAttachments(result?.task_detail?.attachments);
    } else {
      enqueueSnackbar(result.message, { variant: "error" });
    }
    setIsRenameLoading(false);
    setIsOpenRenameDialog(false);
  };

  return (
    <div>
      {attachments.map((item, index) => {
        // console.log(item, "all attachments");
        return (
          <div
            key={index}
            className="col-12 py-2"
            onMouseEnter={() => {
              setHoveredAttachmentId(item._id);
            }}
            onMouseLeave={() => {
              setHoveredAttachmentId();
            }}
          >
            {/* <div className="attachments-container">
              <div className="d-flex">
                {item?.attachment_type !== "image" ? (
                  <a
                    href={s3baseUrl + item?.attachment_path}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <div className="add-task-image">
                      <Iconify
                        className="m-0 p-0"
                        sx={{
                          width: "100%",
                          height: "100%",
                        }}
                        icon={getIconValueFromType(item?.attachment_type)}
                      />
                    </div>
                  </a>
                ) : (
                  <a
                    href={s3baseUrl + item?.attachment_path}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      className="add-task-image"
                      src={s3baseUrl + item?.attachment_path}
                    />
                  </a>
                )}
              </div>
              <div className="attachment-detail">
                <div className="attachment-description ms-3">
                  <Typography fontSize={14} fontWeight={600}>
                    {item?.attachment_name?.length > 20
                      ? item.attachment_name.slice(0, 20) + "..."
                      : item.attachment_name}
                  </Typography>
                  <div className="d-flex">
                    <Typography fontSize={13}>
                      Added{" "}
                      {moment(item.createdAt).format(
                        "ddd, DD-MMM-YYYY hh:mm A"
                      )}
                    </Typography>
                    <Typography className="ms-3" fontSize={13} fontWeight={600}>
                      {item?.attachment_size > 1048576
                        ? (item?.attachment_size / (1024 * 1024)).toFixed(2) +
                          "Mb"
                        : (item?.attachment_size / 1024).toFixed(2) + "Kb"}
                    </Typography>
                  </div>
                </div>
                <div className="attachment-size">
                  {hoveredAttachmentId && hoveredAttachmentId == item._id && (
                    <div>
                      <IconButton
                        size="10px"
                        onClick={() => {
                          handleCopyAttachmentLink(item);
                        }}
                      >
                        <ContentCopyIcon
                          sx={{ width: "16px", height: "16px" }}
                        />
                      </IconButton>
                      <IconButton
                        size="10px"
                        onClick={() => {
                          // setSelectedAttachment(item);
                          handleClickDownload(item);
                        }}
                      >
                        {isDownloading &&
                        selectedAttachment?._id == item._id ? (
                          <CircularProgress
                            size="16px"
                            width="8px"
                            height="6px"
                          />
                        ) : (
                          <DownloadIcon
                            sx={{ width: "16px", height: "16px" }}
                          />
                        )}
                      </IconButton>
                      <IconButton
                        className="me-2"
                        size="10px"
                        onClick={() => {
                          // setSelectedAttachment(item);
                          handleClickOnOpenInNewTab(item);
                        }}
                      >
                        <CallMadeIcon sx={{ width: "16px", height: "16px" }} />
                      </IconButton>
                    </div>
                  )}
                  <div
                    className="sidebar-button d-flex justify-content-center align-items-center"
                    style={{ minWidth: "45px", minHeight: "35px" }}
                    onClick={(e) => {
                      setFileName(item?.attachment_name || "");
                      setSelectedAttachment(item);
                      handleOpenAttachmentDialog(e);
                      // setCurrentFileToremove(
                      //   item.db_path
                      // );
                    }}
                  >
                    <MoreHorizIcon />
                  </div>
                </div>
              </div>
            </div> */}

            <div className="attachments-container row">
              {/* --------------------------------------------------- */}
              <div className={is_mobile_view ? "col-2 p-0" : "col-2"}>
                {item?.attachment_type !== "image" ? (
                  <a
                    href={s3baseUrl + item?.attachment_path}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <div className="add-task-image">
                      <Iconify
                        className="m-0 p-0"
                        sx={{ width: "100%", height: "100%" }}
                        icon={getIconValueFromType(item?.attachment_type)}
                        // color={getColorValueFromType(item?.attachment_type)}
                      />
                    </div>
                  </a>
                ) : (
                  <a
                    href={s3baseUrl + item?.attachment_path}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      className="add-task-image"
                      src={s3baseUrl + item?.attachment_path}
                    />
                  </a>
                )}
              </div>
              {/* --------------------------------------------------- */}
              <div className="col-7">
                <Typography
                  className="attachment-title"
                  fontSize={13}
                  fontWeight={500}
                >
                  {item?.attachment_name}
                </Typography>
                {is_mobile_view ? (
                  <div>
                    <Typography fontSize={9}>
                      {moment(item.created_at).format(
                        "ddd DD-MMM-YYYY hh:mm A"
                      )}
                    </Typography>

                    <Typography fontSize={9} fontWeight={500}>
                      {item?.attachment_size > 1048576
                        ? (item?.attachment_size / (1024 * 1024)).toFixed(2) +
                          "Mb"
                        : (item?.attachment_size / 1024).toFixed(2) + "Kb"}
                    </Typography>
                  </div>
                ) : (
                  <div className="d-flex">
                    <Typography fontSize={11}>
                      Added{" "}
                      {moment(item.created_at).format(
                        "ddd, DD-MMM-YYYY hh:mm A"
                      )}
                    </Typography>
                    <Typography className="ms-3" fontSize={11} fontWeight={500}>
                      {item?.attachment_size > 1048576
                        ? (item?.attachment_size / (1024 * 1024)).toFixed(2) +
                          "Mb"
                        : (item?.attachment_size / 1024).toFixed(2) + "Kb"}
                    </Typography>
                  </div>
                )}
              </div>
              {/* --------------------------------------------------- */}
              <div className="col-3 d-flex justify-content-end align-items-center">
                {!is_mobile_view && (
                  <>
                    {hoveredAttachmentId === item._id && (
                      <div className="d-flex align-items-center me-2">
                        <Tooltip title="Copy Link">
                          <IconButton
                            size="small"
                            onClick={() => handleCopyAttachmentLink(item)}
                          >
                            <ContentCopyIcon sx={{ width: 16, height: 16 }} />
                          </IconButton>
                        </Tooltip>
                        <Tooltip title="Download">
                          <IconButton
                            size="small"
                            onClick={() => {
                              handleClickDownload(item);
                              setSelectedAttachment(item);
                            }}
                          >
                            {isDownloading &&
                            selectedAttachment?._id === item._id ? (
                              <CircularProgress size={16} />
                            ) : (
                              <DownloadIcon sx={{ width: 16, height: 16 }} />
                            )}
                          </IconButton>
                        </Tooltip>
                        <Tooltip title="Open in new Tab">
                          <IconButton
                            size="small"
                            onClick={() => handleClickOnOpenInNewTab(item)}
                          >
                            <CallMadeIcon sx={{ width: 16, height: 16 }} />
                          </IconButton>
                        </Tooltip>
                      </div>
                    )}
                  </>
                )}

                <div
                  className="sidebar-button d-flex justify-content-center align-items-center"
                  style={{
                    minWidth: "45px",
                    minHeight: "35px",
                    pointerEvents: canEditTask ? "auto" : "none",
                    opacity: canEditTask ? 1 : 0.5,
                    cursor: canEditTask ? "pointer" : "not-allowed",
                  }}
                  onClick={(e) => {
                    if (canEditTask) {
                      setFileName(item?.attachment_name || "");
                      setSelectedAttachment(item);
                      handleOpenAttachmentDialog(e);
                    } else {
                      // enqueueSnackbar("Task is not assigned to you", {
                      //   variant: "warning",
                      // });
                    }
                  }}
                >
                  <MoreHorizIcon />
                </div>
              </div>
            </div>
          </div>
        );
      })}
      {localAttachmentsFiles.map((item, index) => {
        return (
          <>
            <div key={index} className="row py-2">
              <div className="col-2">
                {!item?.file?.type?.includes("image") ? (
                  <div className="add-task-image position-relative attach-loading-image">
                    <CircularProgress
                      className="attachment-loading"
                      size={"23px"}
                    />
                    <Iconify
                      className="m-0 p-0"
                      sx={{
                        width: "100%",
                        height: "100%",
                      }}
                      icon={getIconValueFromType(item?.typeData?.baseTypes[0])}
                    />
                  </div>
                ) : (
                  <div className="position-relative">
                    <img
                      className="add-task-image attach-loading-image"
                      src={
                        item?.file instanceof File
                          ? URL.createObjectURL(item?.file)
                          : ""
                      }
                    />
                    <CircularProgress
                      className="attachment-loading"
                      size={"29px"}
                    />
                  </div>
                )}
              </div>

              <div className="col-7">
                {/* <div className="attachment-description"> */}
                <Typography
                  fontSize={12}
                  fontWeight={500}
                  className="attachment-title"
                >
                  {item?.file?.name}
                </Typography>
                <div className="d-flex">
                  <Typography fontSize={12}>
                    <Skeleton variant="text" width={200} />
                  </Typography>
                </div>
                {/* </div> */}
              </div>

              <div className="col-3 d-flex align-items-center justify-content-end">
                <Typography fontSize={11} fontWeight={500}>
                  Uploading File
                </Typography>
              </div>
            </div>

            {/* <div key={index} className="col-12 py-2">
              <div className="attachments-container">
                <div className="d-flex">
                  {!item?.file?.type?.includes("image") ? (
                    <div className="add-task-image position-relative attach-loading-image">
                      <CircularProgress
                        className="attachment-loading"
                        size={"23px"}
                      />
                      <Iconify
                        className="m-0 p-0"
                        sx={{
                          width: "100%",
                          height: "100%",
                        }}
                        icon={getIconValueFromType(
                          item?.typeData?.baseTypes[0]
                        )}
                      />
                    </div>
                  ) : (
                    <div className="position-relative">
                      <img
                        className="add-task-image attach-loading-image"
                        src={
                          item?.file instanceof File
                            ? URL.createObjectURL(item?.file)
                            : ""
                        }
                      />
                      <CircularProgress
                        className="attachment-loading"
                        size={"29px"}
                      />
                    </div>
                  )}
                </div>
                <div className="attachment-detail">
                  <div className="attachment-description ms-3">
                    <Typography fontSize={14} fontWeight={600}>
                      {item?.file?.name}
                    </Typography>
                    <div className="d-flex">
                      <Typography fontSize={13}>
                        <Skeleton variant="text" width={200} />
                      </Typography>
                    </div>
                  </div>
                  <Typography fontSize={11} fontWeight={500}>
                    Uploading File
                  </Typography>
                </div>
              </div>
            </div> */}
          </>
        );
      })}
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={openAttachmentDialog}
        onClose={handleCloseAttachmentDialog}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
      >
        <MenuItem
          onClick={() => {
            handleCloseAttachmentDialog();
            setIsOpenRenameDialog(true);
          }}
        >
          <DriveFileRenameOutlineOutlinedIcon
            className="me-2"
            fontSize="small"
          />
          <Typography fontSize={12} fontWeight={500}>
            Rename File
          </Typography>
        </MenuItem>
        <MenuItem onClick={handleClickDownloadIcon}>
          <DownloadOutlinedIcon className="me-2" fontSize="small" />
          <Typography fontSize={12} fontWeight={500}>
            Download File
          </Typography>
        </MenuItem>

        <MenuItem onClick={handleClickRemove} className="del-dialog-attachment">
          <DeleteOutlineIcon className="me-2" fontSize="small" color="error" />
          <Typography fontSize={12} fontWeight={500} color="error">
            Remove File
          </Typography>
        </MenuItem>
      </Menu>
      <Dialog
        open={isOpenRenameDialog}
        onClose={() => {
          setIsOpenRenameDialog(false);
        }}
        fullWidth
        maxWidth="xs"
      >
        <DialogTitle className="mb-0">
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            Rename File
            <IconButton
              size="small"
              onClick={() => {
                setIsOpenRenameDialog(false);
              }}
            >
              <Iconify
                icon="ion-close"
                sx={{ height: "20px", width: "20px" }}
              />
            </IconButton>
          </Box>
        </DialogTitle>

        <DialogContent sx={{ padding: "0px 20px 20px 20px" }}>
          <form onSubmit={handelRenameFile}>
            <TextField
              name="fileName"
              label="File Name"
              type="text"
              size="small"
              required
              value={fileName}
              onChange={(e) => {
                setFileName(e.target.value);
              }}
              className="mt-2"
              fullWidth
            />
            <div className="d-flex justify-content-end mt-3">
              <LoadingButton
                loading={isRenameLoading}
                type="submit"
                variant="contained"
              >
                Rename
              </LoadingButton>
            </div>
          </form>
        </DialogContent>
      </Dialog>
      <MuiDialog
        open={deleteFileDialogOpen}
        onToggle={(val) => setDeleteFileDialogOpen(false)}
        title="Remove Attachment"
        loading={isDeletingAttachment}
        message="Are you sure you want to remove this attachment?"
        onAgree={() => {
          setIsDeletingAttachment(true);
          console.log("first");
          handleRemoveAttachment();
        }}
      />
    </div>
  );
}
